import React from "react";
import {
  formatTimestampDate,
  formatTimestampLong,
} from "app/containers/Jobs/utils/dateFormat";

const DISPUTED = "Your client has disputed this payment.";

const AMOUNT_MODIFIER = {
  refunded: "jd-payment-amount--struck",
  dispute_lost: "jd-payment-amount--struck",
  disputed: "jd-payment-amount--danger",
};

export const amountModifier = (status) => AMOUNT_MODIFIER[status] || "";

// The card and the confirmation modals must quote the same amount.
export const paymentAmount = (job) => {
  const amount = job.payment?.amount;
  return amount != null ? amount : job.job_setup?.quote;
};

const STRIPE_BUTTON = {
  paid_stripe: { label: "View Details", variant: "outline-primary" },
  refunded: { label: "View Details", variant: "outline-primary" },
  dispute_lost: { label: "View Details", variant: "outline-primary" },
  disputed: { label: "View Dispute", variant: "danger" },
  disputed_review: { label: "View Dispute", variant: "outline-primary" },
};

export const stripeButtonFor = (status) => STRIPE_BUTTON[status] || null;

const lines = (payment, timeZone) => {
  switch (payment.status) {
    case "unpaid":
      return ["Payment request sent.", "Waiting for client."];
    case "paid_manual":
      return [
        "Marked as paid manually.",
        formatTimestampLong(payment.created_at, timeZone),
      ];
    case "paid_stripe":
      return [
        "Paid via Stripe.",
        formatTimestampLong(payment.paid_at, timeZone),
      ];
    case "refunded":
      return [
        "Refunded via Stripe.",
        formatTimestampLong(payment.refunded_at, timeZone),
      ];
    case "disputed":
      return [
        DISPUTED,
        payment.dispute_evidence_due_by && (
          <span className="jd-payment-deadline">
            Respond by{" "}
            {formatTimestampDate(payment.dispute_evidence_due_by, timeZone)}.
          </span>
        ),
      ];
    case "disputed_review":
      return [DISPUTED, "Evidence submitted. Awaiting decision."];
    case "dispute_lost":
      return [
        "Dispute decided in the client's favor.",
        formatTimestampLong(payment.dispute_closed_at, timeZone),
      ];
    default:
      return [];
  }
};

export const PaymentDetail = ({ payment, timeZone }) => {
  const shown = lines(payment, timeZone).filter(Boolean);
  if (shown.length === 0) return null;

  return (
    <div className="jd-subtle">
      {shown.map((line, index) => (
        <div key={index}>{line}</div>
      ))}
    </div>
  );
};
